import { useState } from 'react';
import { NSCard, NSDropdown } from 'bricks';
import { IOptionValue } from 'bricks/types';
import { formatBOEValues, generateScenarioInformation } from '../helper';
import { BOEScenario } from '../types';
import './ScenarioInformation.scss';
import { PropertySizeView } from './SlideoutForm/types';
import { PROPERTY_SIZE_OPTIONS } from './SlideoutForm/constants';
import { getPropertySizeValues } from './SlideoutForm/helpers';
import { isApartmentWithRetailModel } from 'helpers/proForma';

export interface IScenarioInformationProps {
    boeScenario: BOEScenario;
}

const ScenarioInformation = ({ boeScenario }: IScenarioInformationProps) => {
    const [propertySizeView, setPropertySizeView] = useState<IOptionValue<PropertySizeView>>(PROPERTY_SIZE_OPTIONS[0]);
    const scenarioInformation = generateScenarioInformation(boeScenario);
    const isApartmentWithRetail = isApartmentWithRetailModel(boeScenario.propertyTypeId);
    const propertySizeValues = getPropertySizeValues(boeScenario.propertyTypeId, propertySizeView, boeScenario);

    return (
        <div>
            <span className="text-muted">SCENARIO INFORMATION</span>
            {scenarioInformation.map((row, rowIdx) => (
                <div key={row[0]?.title[0]} className="d-flex flex-row py-1 ScenarioInformation">
                    {row.map((section, sectionIdx) => {
                        const isPropertySizeSection = rowIdx === 0 && sectionIdx === 0;

                        if (isPropertySizeSection) {
                            return (
                                <NSCard key={section.title[0]} className="NSCard--level-4 p-3 flex-grow-1">
                                    <div>
                                        <div className="d-flex flex-row ScenarioInformation__mainInfo">
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <span className="text-muted">{section.title[0]}</span>
                                                    {isApartmentWithRetail && (
                                                        <NSDropdown
                                                            options={PROPERTY_SIZE_OPTIONS}
                                                            selectedOption={propertySizeView}
                                                            handleSelectOption={setPropertySizeView}
                                                            isBadgeToggle
                                                            badgeColor="secondary"
                                                            containerClassName="ml-2"
                                                            disableOnSingleOption={false}
                                                        />
                                                    )}
                                                </div>
                                                <h3 className="text-white bold mt-1 mb-2">
                                                    {formatBOEValues(propertySizeValues.builtSf, 'numeralFormatter')}
                                                    <span className="text-muted h4 pl-1">{section.placeholder}</span>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-row pt-2 ScenarioInformation__subItem">
                                        <NSCard className="NSCard--level-5 p-2 flex-grow-1">
                                            <div className="text-start">
                                                <span className="text-muted">Efficiency ratio</span>
                                                <div className="text-white bold">
                                                    {formatBOEValues(propertySizeValues.efficiency, 'formatPercentage')}
                                                </div>
                                            </div>
                                        </NSCard>
                                        <NSCard className="NSCard--level-5 p-2 flex-grow-1">
                                            <div className="text-start">
                                                <span className="text-muted">Net rentable SF</span>
                                                <div className="text-white bold">
                                                    {formatBOEValues(propertySizeValues.netRentableSf, 'numeralFormatter')}
                                                </div>
                                            </div>
                                        </NSCard>
                                    </div>
                                </NSCard>
                            );
                        }

                        return (
                            <NSCard key={section.title[0]} className="NSCard--level-4 p-3 flex-grow-1">
                                {section.title && (
                                    <div>
                                        <div className="d-flex flex-row ScenarioInformation__mainInfo">
                                            {section.title.map((title, idx) => (
                                                <div key={`${title}-title`}>
                                                    <span className="text-muted">{title}</span>
                                                    <h3 className="text-white bold mt-1 mb-2">
                                                        {formatBOEValues(Number(section.value[idx]), section.formatter[idx])}
                                                        {section.placeholder && (
                                                            <span className="text-muted h4 pl-1">{section.placeholder}</span>
                                                        )}
                                                    </h3>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {section.rows.map(sectionRow => (
                                    <div
                                        key={sectionRow[0]?.label}
                                        className="d-flex flex-row pt-2 ScenarioInformation__subItem"
                                    >
                                        {sectionRow.map(
                                            item => item.value !== null && (
                                                <NSCard key={item.label} className="NSCard--level-5 p-2 flex-grow-1">
                                                    <div className="text-start">
                                                        <span className="text-muted">{item.label}</span>
                                                        <div className="text-white bold">
                                                            {item.placeholder
                                                                ? `${formatBOEValues(Number(item.value), item.formatter)} ${item.placeholder}`
                                                                : formatBOEValues(Number(item.value), item.formatter)}
                                                        </div>
                                                    </div>
                                                </NSCard>
                                            ),
                                        )}
                                    </div>
                                ))}
                            </NSCard>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

export default ScenarioInformation;
